import { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// home pages
const Home = lazy(() => import("./pages/home/Home"));

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));

// other pages
const About = lazy(() => import("./pages/about/About"));
const Contact = lazy(() => import("./pages/other/Contact"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/compare/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="glowmonize-preloader-wrapper">
              <div className="glowmonize-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <Routes>
            <Route path={"/"} element={<Home />} />

            {/* Shop pages */}
            <Route path={"/shop"} element={<ShopGridStandard />} />

            {/* Other pages */}
            <Route path={"/about"} element={<About />} />

            <Route path={"/contact"} element={<Contact />} />

            <Route path={"/cart"} element={<Cart />} />
            <Route path={"/wishlist"} element={<Wishlist />} />
            <Route path={"/compare"} element={<Compare />} />
            <Route path={"/checkout"} element={<Checkout />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
